import {Component} from '@angular/core';

@Component({
  selector: 'ctv-root',
  template: `
    <div class="app-wrapper mat-app-background">
      <router-outlet></router-outlet>
      <ctv-loader #loader></ctv-loader>
    </div>`
})
export class AppComponent {
}
